import Axios from "axios";
import { Loading } from "element-ui";
import { Message } from "element-ui";
import router from "../router";

const ajax = function ajax(
  url,
  data = {},
  type = "GET",
  loading = false,
  loadingLock = {}
) {
  let loadingInstance;
  if (loading) {
    loadingInstance = Loading.service({
      text: "正在加载...",
      spinner: "el-icon-loading",
    });
  }
  if (loadingLock && loadingLock.text) {
    loadingInstance = Loading.service({
      lock: true,
      text: loadingLock.text,
      background: "rgba(0,0,0,0.5)",
    });
  }
  return new Promise((resolve, reject) => {
    let promise;
    if (type === "GET") {
      promise = Axios.get(url, {
        // headers: {"Authorization": window.sessionStorage.getItem("token")},
        Accept: "application/json",
        params: data,
      });
    } else if (type == "POSTJSON") {
      const config = {
        headers: { "Content-Type": "application/json" },
        Accept: "application/json",
        data: data,
        //withCredentials: true
      };
      promise = Axios.post(url, data, config);
    } else if (type == "POST") {
      const config = {
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        Accept: "application/json",
        params: data,
      };
      promise = Axios.post(url, data, config);
    } else if (type == "BODY") {
      const config = {
        headers: { "Content-Type": "multipart/form-data" },
      };
      promise = Axios.post(url, data, config);
    }

    promise.then((response) => {
      if (response.status == 401) {
        console.log(response);
        window.localStorage.clear();
        Message.error("登录已过期，请重新登录");
        router.replace({
          path: "/login",
          query: { redirect: router.currentRoute.fullPath },
        });
      } else {
        resolve(response.data);
      }
    });

    promise.catch((error) => {
      if (error.response.status == 400) {
        Message.error("参数提交错误");
      }
      if (error.response.status == 401) {
        window.localStorage.clear();
        Message.error("登录已过期，请重新登录");
        router.replace({
          path: "/login",
          query: { redirect: router.currentRoute.fullPath },
        });
      }
    });

    if (loadingInstance) {
      loadingInstance.close();
    }
  });
};

// 请求拦截器，给请求头中放入token值
Axios.interceptors.request.use((config) => {
  config.headers.Authorization = "token: " + window.localStorage.getItem("jwt");
  return config;
});

export default ajax;
